import { FC, useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import Box from '@material-ui/core/Box';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Button from 'components/button';
import SuccessCheckAnimationIcon from './icons/SuccessCheckAnimationIcon';
import { KeycloakContext } from './Secured';
import { useAppContext } from 'AppContext';

interface FirstProductDialogProps {
  isDraft: boolean;
}

export const FirstProductDialog: FC<FirstProductDialogProps> = ({ isDraft }) => {
  const history = useHistory();
  const keycloakCtx = useContext(KeycloakContext);
  const isProducer = keycloakCtx.keycloak.hasResourceRole('producer');
  const { loadingProductsSummary, allProductCount, reloadAllProductCount } = useAppContext();

  const [open, setOpen] = useState(false);

  const handleSubmit = () => {
    setOpen(false);
    if (isProducer) {
      reloadAllProductCount();
      if (isDraft) {
        history.push(`/products?tab=draftProducts`);
      } else {
        history.push('/products');
      }
    }
  };

  useEffect(() => {
    if (isProducer && !loadingProductsSummary && !allProductCount) {
      setOpen(true);
    }
  }, [isProducer, loadingProductsSummary, allProductCount]);

  return (
    <Dialog open={open} PaperProps={{ style: { borderRadius: 16, maxWidth: 800 } }}>
      <DialogContent style={{ padding: '24px 40px 0 40px' }}>
        <Box display="flex" justifyContent="center">
          {open && <SuccessCheckAnimationIcon />}
        </Box>
        <Box mb={1} fontWeight={700} fontSize={24} textAlign="center">
          Bra jobbat! Din första produkt är nu skapad!
        </Box>
        <Box border="1px solid rgba(0, 0, 0, 0.2)" borderRadius={12} p={2.5}>
          <Box mb={2}>
            <Box fontWeight={700}>Nästa steg:</Box>
            <Box>
              <b>1. Leverantörsgodkännande</b>{' '}
              <span>– Om du inte redan är det, kommer vi först att godkänna dig som leverantör.</span>
            </Box>
            <Box>
              <b>2. Produktgranskning</b>{' '}
              <span>– Våra experter säkerställer att produktinformationen följer alla krav.</span>
            </Box>
            <Box>
              <b>3. Export</b>{' '}
              <span>
                – När allt är godkänt skickas produkten vidare till de återförsäljare du redan samarbetar med i butik
                och som är anslutna till Sygrid.
              </span>
            </Box>
          </Box>
          <Box mb={2}>
            <Box fontWeight={700}>Har du fler produkter?</Box>
            <Box>
              Lägg gärna till dem när det passar! Efter den första produkten tillämpas vår pristrappa, så du betalar
              bara för det antal produkter som faktiskt är aktiva.
            </Box>
            <Box>
              👉 Se aktuella nivåer och beräkna kostnaden på{' '}
              <a href="https://sygrid.com" style={{ textDecoration: 'none' }}>
                https://sygrid.com
              </a>
              .
            </Box>
          </Box>
          <Box mb={2}>
            <Box>
              Behöver du hjälp? Vi finns här – hör av dig till{' '}
              <a href="mailto:support@sygrid.com" style={{ textDecoration: 'none' }}>
                support@sygrid.com
              </a>
              .
            </Box>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Box display="flex" gridGap={16} px={4} py={2}>
          <Button size="small" variant="contained" color="primary" onClick={handleSubmit}>
            Fortsätt
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default FirstProductDialog;
